export default "__VITE_ASSET__BDw$i4xK__"